import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import * as React from 'react';
var SvgComplete = React.forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M16 0c4.095 0 8.189 1.562 11.313 4.687 6.249 6.248 6.249 16.378 0 22.626C24.189 30.438 20.095 32 16 32s-8.189-1.562-11.313-4.687c-6.249-6.248-6.249-16.378 0-22.626A15.945 15.945 0 0 1 16 0zm0 4a11.919 11.919 0 0 0-8.485 3.515c-4.679 4.678-4.679 12.292 0 16.97C9.781 26.752 12.795 28 16 28s6.219-1.248 8.485-3.515c4.679-4.678 4.679-12.292 0-16.97A11.919 11.919 0 0 0 16 4zm3.987 5.961a1.5 1.5 0 0 1 2.655 1.397l-5.821 11.064a1.5 1.5 0 0 1-2.282.459l-6.197-5.113a1.5 1.5 0 1 1 1.91-2.314l4.774 3.939 4.962-9.431z"
  }));
});
export default SvgComplete;